import mixpanel from 'mixpanel-browser';
import _ from 'lodash';
import { mixPanel } from 'src/config';

export default class EventService {
  static initialiseMixpanel(){
    mixpanel.init(mixPanel.appId);
  }

  static getMixpanelDistinctId() {
    return mixpanel.get_distinct_id();
  }

  static trackEvent(name, props) {
    mixpanel.track(name, props);
  }
   
  static getExperienceType(key) {
    let experienceType = "";

    switch (key) {
        case "MASONRY":
            experienceType = "Metro";
            break;
        case "CAROUSEL":
            experienceType = "Carousel";
            break;
        case "DEAL_ROOM":
            experienceType = "Deal Room";
            break;
        default:
            experienceType = "";
            break;
    }

    return experienceType;
}


  static getViewerType(key) {
    let viewerType = "";

    switch (key) {
      case "LIST_VIEWER":
        viewerType = "List";
        break;
      case "IMMERSE_VIEWER":
        viewerType = "Immerse";
        break;
      case "GALLERY_VIEWER":
        viewerType = "Gallery";
        break;
      default:
        viewerType = "";
        break;
    }

    return viewerType;
  }

  static getSourceType(key) {

    var sourceType = "";
    switch (key) {
      case "gdrive":
        sourceType = "Google Drive";
        break;

      case "onedrive":
        sourceType = "OneDrive";
        break;

      case "sharepoint":
        sourceType = "SharePoint";
        break;
      
      case "dropbox":
        sourceType = "Dropbox";
        break;
      
      case "box":
        sourceType = "Box";
        break;
      
      default:
        sourceType = _.capitalize(sourceType);
        break;
    }

    return sourceType;
  }


  static getSourceCta(key) {

    var sourceCta = "";
    switch (key) {
      case "streams":
        sourceCta = "Stream";
        break;

      case "groups":
        sourceCta = "Group";
        break;

      case "collections":
        sourceCta = "Collection";
        break;

      case "conversations":
        sourceCta = "Conversation";
        break;

      case "reports":
        sourceCta = "Reports";
        break;
      
      case "hub":
        sourceCta = "Content Map";
        break;
      
      default:
        sourceCta = "";
        break;
    }

    return sourceCta;
  }

  static getSourceNameType(key){
    var sourceNameType = "";

    switch (key) {
      
      case "Stream":
        sourceNameType = "stream_name";
        break;
      
      case "Group":
        sourceNameType = "group_name";
        break;
      
      case "Collection":
        sourceNameType = "collection_name";
        break;
      
      default:
        sourceNameType = "source_name";
        break;
    }
    
    return sourceNameType;
  }

  static shouldTriggerEvent(source){
    switch(source){
      case "chrome_extension":
      case "hubspot": 
      case "salesforce":
        return false;
      default:
        return true;
    }
  }
  
  static getLegendName(key){
    var mapFilterName = "";

    switch (key) {
      case "all":
        mapFilterName = "My Recipients";
        break;
      case "live":
        mapFilterName = "Live Users";
        break;
      case "unread":
        mapFilterName = "Unread Chats";
        break;
      default:
        mapFilterName = "";
        break;
    }

    return mapFilterName;
  }

  static getMapFilterName(key){
    var legendName = "";

    switch (key) {
      case "all":
        legendName = "All";
        break;
      case "live":
        legendName = "Live";
        break;
      case "last24Hours":
        legendName = "Last 24 Hours";
        break;
      case "lastWeek":
        legendName = "Last 7 Days";
        break;
      default:
        legendName = "";
        break;
    }

    return legendName;
  }
  
  static getClusterPropertyType(key){
    var clusterPropertyType = "";

    switch (key) {
      
      case "asset":
        clusterPropertyType = "isAssetFilter";
        break;
      
      case "title":
        clusterPropertyType = "isAssetTitleFilter";
        break;
      
      case "stream":
        clusterPropertyType = "isStreamFilter";
        break;

      case "file_type":
        clusterPropertyType = "isFileTypeFilter";
        break;
      
      case "tags":
        clusterPropertyType = "isTagFilter";
        break;
      
      case "group":
        clusterPropertyType = "isGroupFilter";
        break;
      
      case "expiryDate":
        clusterPropertyType = "isAssetStatusFilter";
        break;
      
      default:
        clusterPropertyType = "";
        break;
    }

    return clusterPropertyType;
  }
}